import {useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Title} from "../../../components/components";
import FormButton from "../../../components/forms/FormButton";
import React from "react";
import GeojsonFilter from "../../../components/zones/GeojsonFilter";
import CoordinatesFilter from "../../../components/zones/CoordinatesFilter";
import AdminBoundariesFilter from "../../../components/zones/AdminBoundariesFilter";
import { useGetZoneQuery } from "../../../api/zoneApiSlice";

function Zone(props) {
  const { zoneId } = useParams();
  const {data: zone, isSuccess} = useGetZoneQuery(zoneId)
  const { t } = useTranslation();

  if(!isSuccess) { return (<></>) }
  return (
    <>
      <Title main={t("menu.zones")} sub={zone.name} backPath="/zones">
        <FormButton edit state={{zone}}/>
      </Title>
      {zone.type === 'geojson' && <GeojsonFilter geojson={zone.content}  />}
      {zone.type === 'coordinates' && <CoordinatesFilter coordinates={zone.content.coordinates} defaultRadius={zone.content.radius}  />}
      {zone.type === 'admin_boundaries' && <AdminBoundariesFilter value={zone.content} />}
    </>
  )
}

export default Zone
